import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_ITEM_BEGIN,
  COLLECTIONS_DELETE_ITEM_SUCCESS,
  COLLECTIONS_DELETE_ITEM_FAILURE,
  COLLECTIONS_DELETE_ITEM_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteItem(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_ITEM_BEGIN,
    });
    const { projectId, collectionName, itemId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/item/${itemId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: COLLECTIONS_DELETE_ITEM_SUCCESS,
              itemId: args.itemId,
            });
            toast.success('Item deleted successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_ITEM_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion Failed: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_ITEM_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg} `);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteItemError() {
  return {
    type: COLLECTIONS_DELETE_ITEM_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_ITEM_BEGIN:
      return {
        ...state,
        deleteItemPending: true,
        deleteItemError: null,
      };

    case COLLECTIONS_DELETE_ITEM_SUCCESS:
      const items = state.items.filter((item) => item.uuid !== action.itemId);
      return {
        ...state,
        deleteItemPending: false,
        deleteItemError: null,
        items: items,
      };

    case COLLECTIONS_DELETE_ITEM_FAILURE:
      return {
        ...state,
        deleteItemPending: false,
        deleteItemError: action.data.error,
      };

    case COLLECTIONS_DELETE_ITEM_DISMISS_ERROR:
      return {
        ...state,
        deleteItemError: null,
      };

    default:
      return state;
  }
}
